<template>
  <div>
    <div v-if="!total || !total.views" class="tf-card">
      <div class="an-empty">
        <i class="fa fa-bug"></i>
        <span>За период просмотров с итогами нет</span>
      </div>
    </div>

    <template v-else>
      <div class="an-tiles">
        <div v-for="col in columns" :key="col.key" class="an-tile" :title="col.hint">
          <div class="an-tile__top"><span class="an-tile__title">{{ col.title }}</span></div>
          <div class="an-tile__value">{{ col.format(total[col.key]) }}</div>
          <div class="an-tile__sub">{{ col.hint }}</div>
        </div>
      </div>

      <section v-for="block in blocks" :key="block.key" class="tf-card">
        <div class="tf-card__head">
          <span class="tf-card__icon"><i class="fa" :class="block.icon"></i></span>
          <div class="tf-card__titles">
            <h3 class="tf-card__title">{{ block.title }}</h3>
          </div>
        </div>
        <div class="tf-card__body an-table-wrap">
          <table class="an-table">
            <thead>
            <tr>
              <th>{{ block.nameTitle }}</th>
              <th class="an-num">Просмотры</th>
              <th v-for="col in columns" :key="col.key" class="an-num" :title="col.hint">{{ col.title }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in block.rows" :key="row.key">
              <td>
                {{ row.label }}
                <span v-if="block.showKey && row.key !== row.label" class="an-cell-sub">{{ row.key }}</span>
              </td>
              <td class="an-num">{{ formatCount(row.views) }}</td>
              <td v-for="col in columns" :key="col.key" class="an-num">{{ col.format(row[col.key]) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import {formatCount, formatPercent} from "@/common/rumFormat";

const ROUTES_LIMIT = 20

export default {
  name: "RumHealth",
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    total() {
      return this.data.total || null
    },
    columns() {
      return [
        {key: 'errorRate', title: 'С ошибками', hint: 'Доля просмотров, где была хоть одна ошибка JS', format: v => formatPercent(v)},
        {key: 'chunkRate', title: 'Не загрузился код', hint: 'Не догрузился кусок сайта — обычно сразу после деплоя', format: v => formatPercent(v)},
        {key: 'notMountedRate', title: 'Сайт не запустился', hint: 'Человек так и не увидел работающую страницу', format: v => formatPercent(v)},
        {key: 'errorsPerView', title: 'Ошибок на просмотр', hint: 'Сколько ошибок в среднем на один просмотр', format: v => (v === null || v === undefined ? '—' : String(v))},
      ]
    },
    blocks() {
      const blocks = []
      const releases = this.data.byRelease || []
      const routes = this.data.byRoute || []
      if (releases.length) {
        blocks.push({key: 'rel', title: 'По релизам', nameTitle: 'Релиз', icon: 'fa-rocket', rows: releases})
      }
      if (routes.length) {
        blocks.push({
          key: 'route',
          title: routes.length > ROUTES_LIMIT ? `По страницам — первые ${ROUTES_LIMIT} по просмотрам` : 'По страницам',
          nameTitle: 'Страница',
          icon: 'fa-file-o',
          showKey: true,
          rows: routes.slice(0, ROUTES_LIMIT),
        })
      }
      return blocks
    },
  },
  methods: {formatCount},
}
</script>
